import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getHomeBreadcrumbMap({
  pathname,
  t,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });

  return [
    {
      condition: APP_URLS.dashboard.home.isTheSameUrlAs(pathname),
      data: [{ label: t('home-page') }],
    },
    {
      condition: APP_URLS.dashboard.homeWidgets.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, { label: t('home.manage-widget-templates') }],
    },
    {
      condition: APP_URLS.dashboard.homeEdit.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, { label: t('home.manage-widget-templates') }],
    },
    {
      condition: APP_URLS.dashboard.homeWidgetsCreate.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('home.manage-widget-templates'),
          path: APP_URLS.dashboard.homeWidgets.getPathWithQuery(),
        },
        { label: t('home.create-widget-template') },
      ],
    },
    {
      condition: APP_URLS.dashboard.overview.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('overview'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.timeline.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('timeline'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.monitoring.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('monitoring'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.profile.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('profile'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.publicApi.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('public-api'),
        },
      ],
    },
    {
      condition:
        APP_URLS.dashboard.companyDomains.index.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, { label: t('domains') }],
    },
    {
      condition: APP_URLS.dashboard.reminder.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, { label: t('reminder') }],
    },
    {
      condition: APP_URLS.dashboard.companyPlan.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, { label: t('company-plan') }],
    },
    {
      condition: APP_URLS.dashboard.dataImport.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('import'),
        },
      ],
    },
  ];
}
